import dayjs from 'dayjs'
import ClearIcon from '@mui/icons-material/Clear'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { Box, FormControl, IconButton, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material'

import { QUERY_PARAMS } from '../../../constants'
import { useSearchParams } from 'react-router-dom'
import { AccountsDropdown } from '../../common/ChartOfAccountsDropdown'

const ReconciliationFilters = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const getFilterValues = (key: QUERY_PARAMS) => searchParams.get(key) || ''
  const setParams = (key: string, value: string) => {
    searchParams.set(key, value)
    setSearchParams(searchParams)
  }
  const accountId = getFilterValues(QUERY_PARAMS.ACCOUNT_ID)
  const statementMonth = getFilterValues(QUERY_PARAMS.STATEMENT_MONTH)
  const reconciliationStatus = searchParams.get(QUERY_PARAMS.RECONCILIATION_STATUS)

  const handleChangeStatementMonth = (statementMonth: dayjs.Dayjs | null) => {
    if (statementMonth) {
      setParams(QUERY_PARAMS.STATEMENT_MONTH, dayjs(statementMonth).format('YYYY-MM-DD'))
    } else {
      searchParams.delete(QUERY_PARAMS.STATEMENT_MONTH)
      setSearchParams(searchParams)
    }
  }

  const handleReconciliationStatus = (event: SelectChangeEvent) => {
    setParams(QUERY_PARAMS.RECONCILIATION_STATUS, event.target.value)
  }

  return (
    <Box width="100%">
      <Box display={'flex'} alignItems={'center'} gap={2} flexWrap={'wrap'}>
        <Box>
          <Box sx={{ marginBottom: '4px', color: '#6E0000' }}>Accounts</Box>
          <AccountsDropdown setParams={setParams} accountId={accountId} isBankAccount={true} />
        </Box>

        <Box>
          <Box sx={{ marginBottom: '4px', color: '#6E0000' }}>Reconciliation Month</Box>
          <FormControl variant="outlined">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                views={['year', 'month']}
                value={statementMonth ? dayjs(statementMonth) : null}
                onChange={value => {
                  handleChangeStatementMonth(value)
                }}
                renderInput={params => (
                  <TextField
                    {...params}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {statementMonth && (
                            <IconButton onClick={() => handleChangeStatementMonth(null)} size="small" edge="end">
                              <ClearIcon fontSize="small" />
                            </IconButton>
                          )}
                          {params.InputProps?.endAdornment}
                        </>
                      )
                    }}
                    inputProps={{ ...params.inputProps, readOnly: true }}
                  />
                )}
                maxDate={dayjs().add(1, 'month').endOf('month')}
                minDate={dayjs().subtract(25, 'year').startOf('year')}
              />
            </LocalizationProvider>
          </FormControl>
        </Box>

        <Box width="250px">
          <InputLabel id="reconciliation-status" sx={{ marginBottom: '4px', color: '#6E0000' }}>
            Status
          </InputLabel>
          <FormControl fullWidth>
            <Select
              labelId="reconciliation-status"
              value={reconciliationStatus || 'active'}
              onChange={handleReconciliationStatus}
            >
              <MenuItem value="active" selected>
                Active
              </MenuItem>
              <MenuItem value="reverted">Reverted</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Box>
    </Box>
  )
}

export default ReconciliationFilters
